import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './forbidden.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forbidden.component.css',
})
export class ForbiddenComponent {
  private router = inject(Router);

  goHome(): void {
    this.router.navigate(['/']);
  }
}
